import React, { Fragment } from "react";

import { TableTabs } from "../../../shared/components";
import { RoamingInfo } from "../../../../../../components/roamingInfo/RoamingInfo";
import {
  MobileSort,
  TableSearch,
} from "../../../../../../components/table/components";
import { Mobile, NotMobile } from "../../../../../../hocs/Responsive";
import { RoamingLimitReachedWarning } from "../../../../../../components/roamingInfo/RoamingLimitReachedWarning";

import "./RoamingDevicesTableHeader.scss";

export const MobileSortRoamingCounter = () => {
  return (
    <div className="mobile-sort-roaming-counter">
      <MobileSort />
      <RoamingInfo />
    </div>
  );
};

export const RoamingDevicesTableHeader = () => {
  return (
    <Fragment>
      <TableTabs />
      <NotMobile>
        <RoamingInfo />
      </NotMobile>
      <TableSearch />
      <Mobile>
        <MobileSortRoamingCounter />
      </Mobile>
      <RoamingLimitReachedWarning />
    </Fragment>
  );
};
